import axios from 'axios';
import {
  APP_SETTING_GET_PROFILER_DATA_BEGIN,
  APP_SETTING_GET_PROFILER_DATA_SUCCESS,
  APP_SETTING_GET_PROFILER_DATA_FAILURE,
  APP_SETTING_GET_PROFILER_DATA_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function getProfilerData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_GET_PROFILER_DATA_BEGIN,
    });
    const { projectId, version, page = 1, limit = 10 } = args;

    const header = builderSurfaceJsonContentHeader(projectId);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}profiler/list?page=${page}&limit=${limit}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_GET_PROFILER_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_GET_PROFILER_DATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetProfilerDataError() {
  return {
    type: APP_SETTING_GET_PROFILER_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_GET_PROFILER_DATA_BEGIN:
      return {
        ...state,
        getProfilerDataPending: true,
        getProfilerDataError: null,
      };

    case APP_SETTING_GET_PROFILER_DATA_SUCCESS:
      return {
        ...state,
        getProfilerDataPending: false,
        getProfilerDataError: null,
        profilersList: action.data,
      };

    case APP_SETTING_GET_PROFILER_DATA_FAILURE:
      return {
        ...state,
        getProfilerDataPending: false,
        getProfilerDataError: action.data.error,
      };

    case APP_SETTING_GET_PROFILER_DATA_DISMISS_ERROR:
      return {
        ...state,
        getProfilerDataError: null,
      };

    default:
      return state;
  }
}
